import { FileUpload, FilterAltOff } from "@mui/icons-material";
import { useCallback, useEffect, useState } from "react";
import { EditButton, Button, Datagrid, Filter, List, TextField, TextInput, Toolbar, useAuthProvider, useNotify, useRecordContext } from "react-admin";
import dataProvider from "../../dataProvider";

const CustomFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Name in TC" source="name_tc" alwaysOn />
    <TextInput label="Name in EN" source="name_en" alwaysOn />
  </Filter>
);

// List page
export const FilteringList = (props) => {
  const auth = useAuthProvider();
  const [canEdit, setCanEdit] = useState(false);

  useEffect(async () => {
    const p = await auth.getPermissions();

    if (p.includes("edit_subcat_filter")) {
      setCanEdit(true);
    }
  }, []);

  const OverwriteButton = () => {
    const record = useRecordContext();

    return <EditButton basePath="/subcat-filter-overwrite-list" record={record} label="Overwrite filter" icon={<FilterAltOff />} />;
  };

  return (
    <List {...props} resource="subcat-filters" bulkActionButtons={false} filters={<CustomFilter />} actions={<CustomListActions canEdit={canEdit} />}>
      <Datagrid>
        {/* <TextField label="Tag ID" source="category_tag_id" /> */}
        <TextField label="Tag ID" source="tag_id" />
        <TextField label="Type" source="type" />
        <TextField label="Name in TC" source="name_tc" />
        <TextField label="Name in EN" source="name_en" />
        <OverwriteButton />
        <EditButton />
      </Datagrid>
    </List>
  );
};

const CustomListActions = function ({ canEdit }) {
  const notify = useNotify();
  const [disableButton, setDisableButton] = useState(false);

  // click Update Filtering
  const onClick = useCallback(async (event) => {
    event.preventDefault();

    setDisableButton(true);

    // check import-reqeusts
    const checkFunction = async () => {
      const result = await dataProvider.getImportRequestForSubcatFilters();

      if (result && result.data && result.data.status == "DONE") {
        notify("Update Filtering success", "success");
        setDisableButton(false);
      } else if (result && result.data && ["NEW", "IN_PROGRESS"].includes(result.data.status)) {
        setTimeout(checkFunction, 1000);
      } else {
        const message = result && result.data && result.data.message ? result.data.message : "Update Filtering ERROR";

        notify(message, "warning");
        setDisableButton(false);
      }
    };

    // POST import-requests
    await dataProvider.postImportRequestForSubcatFilters();

    setTimeout(checkFunction, 1000);
  });

  return (
    <Toolbar style={{ padding: 0, margin: 0, backgroundColor: "transparent" }}>
      {/* button link to Import Request List page  */}
      <Button label="Update filtering" variant="outlined" style={{ width: "unset" }} onClick={onClick} disabled={!canEdit || disableButton}>
        <FileUpload />
      </Button>

      {/* default Export Button  */}
      {/* <ExportButton /> */}
    </Toolbar>
  );
};
